/** Fase 2 (W33, item 5.6): page subtitles in English (see `subtitulos-pt.ts`). */
export const subtitulosEn = {
  inicio: 'Business overview for the chosen period',
  automacoes: 'Robots and automated routines of the operation, in one place',
  externo: 'Outside system opened inside MalgoOS; sign-in and data stay with it',
  subsistemas: 'Choose the company and the subsystem; the menu shows only what belongs to it',
  notificacoes: 'Follow every system notification and choose how to receive each one',
  conta: {
    perfil: 'Manage your personal information and see your access',
    aparencia: 'Choose theme, accent color, font and text size just for you',
    seguranca: 'Password, two-step verification, passkeys and open sessions',
    assistentes: 'Your AI assistants, what they prepared and the usage in the period',
    lixeira: 'What you deleted in the last 30 days, with the option to undo',
    'meus-dados': 'Your employee record: personal data, contract, salary, documents and history',
  },
  paginas: {
    cadastros: {
      pessoas: 'Customers, suppliers and partners in one place: a person can hold several roles',
      projetos: 'Customer projects, to group contracts, tasks and entries',
      classificacao: 'Tags and sectors to classify and filter records',
      servicos: 'Manage the services offered to customers',
      'servicos-contratados': 'Services your company hires from third parties (accountant, cleaning, IT...)',
      'condicoes-pagamento': 'Terms and installments used in sales, purchases and bills',
      'formas-pagamento': 'Manage the payment methods the company accepts',
    },
    financeiro: {
      'centros-custo': 'Manage the cost centers',
      contas: "Manage the company's financial accounts (banks and cash)",
      categorias: "The company's chart of accounts",
      'entradas-saidas': 'All the money that came in and went out of your accounts',
      conciliacao: 'Check your bank statement against the system (reconciliation) to see what came in and went out',
      'fluxo-caixa': 'Inflows and outflows by period, actual and forecast',
      indices: 'Adjustment indexes (IPCA, IGP-M and others) used in contracts',
    },
    contas: {
      'a-receber': 'Bills your customers will pay',
      'a-pagar': 'Bills you will pay',
      cobrancas: 'Payment reminders: messages to customers before and after the due date',
      recorrencias: 'Subscriptions and fixed bills issued on their own every cycle',
      'notas-credito': 'Credit notes issued to customers, which reduce the amount receivable',
    },
    relatorios: {
      inicio: 'Financial and operational analyses',
      'painel-grupo': 'Revenue, expenses, balances, contracts and people of each group company and the total',
      inadimplencia: 'Overdue bills by days overdue',
      dre: 'Income statement for the period',
      fluxo: 'Inflows and outflows by period, actual or forecast, down to the entry',
      extrato: 'Inflows and outflows (receivable and payable) with running balance',
      centros: 'Revenue and expenses of each cost center',
      parceiros: 'Revenue by customer and expenses by supplier, ranked by amount',
      mrr: 'Monthly recurring revenue from active contracts',
      margem: 'Revenue, cost and margin of each service sold',
      quadro: 'How many people there are by department, role and status',
      folha: 'Payroll totals for each period',
      exportacoes: 'Files exported from the reports, ready to download',
    },
    agenda: {
      recursos: 'Professionals, rooms and equipment that take appointments',
      semana: 'Appointments of the week, by professional or resource',
      dia: 'Appointments of the day, hour by hour',
      mes: 'The whole month of appointments',
    },
    estoque: {
      produtos: 'Manage the product catalog',
      variacoes: 'Product variants (size, color) and units of measure',
      depositos: 'Places where the stock is kept',
      movimentacoes: 'Stock receipts, issues and transfers',
      reposicao: 'Products below the minimum and what needs to be bought',
      inventario: 'Stock counts and adjustments of the differences',
      lotes: 'Product lots and expiry dates',
    },
    pipeline: {
      pipeline: 'Your sales in progress, stage by stage',
      equipes: 'Sales teams and who is in each one',
      metas: 'Sales targets by period, team and salesperson',
      'motivos-perda': 'Reasons used when marking an opportunity as lost',
      atividades: 'Calls, meetings and tasks tied to the opportunities',
    },
    conversas: {
      whatsapp: 'Conversations with customers on WhatsApp',
      instagram: 'Direct messages received on Instagram',
      email: 'Shared e-mail inbox with customers',
      portal: 'Messages sent by customers in the portal',
      'respostas-rapidas': 'Ready-made texts to insert in conversations with a shortcut',
      templates: 'Message templates approved by Meta to start WhatsApp conversations',
      filas: 'Service queues: groups of people who answer together',
      automacoes: 'Entry menu per channel and automatic keyword replies',
      site: 'Conversations started through the chat on your websites',
      'chat-site': 'Chat for your websites: domains, queue, look and the code to paste',
    },
    assinaturas: {
      contratos: 'Manage the contracts with customers',
      planos: 'Catalog of plans with price, recurrence and items to create contracts',
      reajustes: 'Approval of index adjustments on the anniversary of open-ended contracts',
      onboarding: 'Customer cycle settings and the onboarding template opened when a contract is activated',
    },
    portal: {
      acessos: 'Which of your customers sign in to the portal and what each one sees',
      configuracao: 'How the customer portal looks and what it offers',
    },
    pessoas: {
      funcionarios: "The company's employee records",
      departamentos: 'Departments and who is in charge of each one',
      funcoes: 'Roles and positions used in employment contracts',
      contratos: 'Employment contracts, hirings and terminations',
      documentos: 'Confidential employee documents',
      jornada: 'Work hours and shift patterns',
      habilidades: 'Skills and certifications of each employee',
    },
    folha: {
      beneficios: 'Benefits offered and who receives each one',
      eventos: 'Earnings and deductions used in the payroll calculation',
      competencias: 'Payroll of each month, from calculation to closing',
      holerites: 'Payslips generated for each employee',
      configuracao: 'Rules and accounts used when closing the payroll',
    },
    compras: {
      compras: 'Service purchases that create payables',
      requisicoes: 'Internal purchase requests, for approval',
      cotacoes: 'Prices requested from suppliers, side by side',
      pedidos: 'Purchase orders sent to suppliers',
      recebimentos: 'Checking what arrived from the purchase orders',
      fornecedores: 'Suppliers the company buys from',
    },
    tarefas: {
      kanban: 'Tasks in columns by status, to drag and drop',
      lista: 'All tasks in a list, with filters',
      minhas: 'The tasks assigned to you',
      painel: 'Task indicators: deadlines, delays and deliveries',
      quadros: 'Boards that organize tasks by project or team',
      projetos: 'Projects with client, team, deadline, budget and the task board',
      marcos: 'Key project dates, from the closest to the farthest',
    },
    equipe: {
      chat: 'Team conversations and channels',
    },
    automacoes: {
      painel: 'Robots dashboard: status, last and next run, monthly score and pending queue',
      feriados: 'Holiday calendar skipped by the robots business day windows',
      fluxos: 'Instagram and WhatsApp conversation automations, drawn on a canvas',
      broadcast: 'WhatsApp template broadcasts to an audience, with consent, rate and report',
    },
    treinamento: {
      cursos: 'Courses and lessons available to the team',
      trilhas: 'Course sequences by role or goal',
      progresso: "Who took each course and each person's progress",
    },
    ponto: {
      marcar: 'Clock in: server time, today punches and the schedule of the day',
      marcacoes: 'Time clock punches with the source, the device time and the location',
      espelho: 'Expected by the schedule against worked, day by day, with overtime, late arrivals and absences',
      ajustes: 'Forgotten or invalid punch, with justification and approval',
      banco: 'Hour balance of the closed months and what expires soon',
      fechamentos: 'Closed months per company: locks the time clock and hands the result to payroll',
      fiscal: 'Official time clock (REP-P) and the AFD and AEJ files per period, signed with the certificate',
      configuracao: 'Tolerances, contracts that clock in and the policy per company, department or employee',
    },
    ausencias: {
      pedidos: 'Vacations, sick notes, days off and leaves requested by the team',
      aprovacoes: 'Time off requests waiting for your decision',
      calendario: 'Who is away or requested time off in each month',
      saldos: 'Days each employee is entitled to, used and available in the year',
      tipos: 'Time off types and their balance, count and approval rules',
    },
    documentos: {
      arquivos: 'Files linked to customers, projects and employees, with their versions',
      contratos: 'Contracts generated from templates with the record data',
      assinaturas: 'Documents sent for signature, with the trail of each signature',
    },
    despesas: {
      despesas: 'Team expenses with receipt, category and cost center',
      aprovacoes: 'Sent expenses waiting for your decision',
      reembolsos: 'Approved expenses that become payables in Receivables and payables',
      centros: 'Approved and reimbursed in the period, by cost center',
    },
    integracoes: {
      conectores: 'External services linked to the system: WhatsApp, e-mail, billing and calendar',
      webhooks: 'Notices sent to other systems when something happens here',
      api: "Access keys to the system's API and the call log",
      mcp: 'MCP server for AI agents to use the system',
      'conta-azul': 'Conta Azul until the cutover: mirror, comparison with MalgoOS and file to import',
    },
    admin: {
      painel: 'System health: database, queues, live version and alerts',
      modulos: 'Install and turn off modules without a deploy',
      tenants: 'Tenants and workspaces served by the platform',
      usuarios: 'Manage the system users and permissions',
      auditoria: 'Record of who did what, and when',
      saude: 'Versions, services and scheduled jobs of the server',
      erros: 'What the person was trying to do when the screen failed, to fix and redo it',
      'historico-telas': 'Screens before and after each change, with images from the server',
      'tela-entrada': 'The logo and background image of the sign-in and sign-out screens, the same for everyone',
      'uso-ia': 'Claude Code tokens and cost by day, week, month and year',
    },
    configuracoes: {
      empresa: 'Details of the workspace companies, used in documents and e-mails',
      aparencia: "Customize the system's name, logo, colors and font",
      modos: 'How each module works: simple or detailed',
      subsistemas: 'Where each page appears: by subsystem, in the workspace and in each company',
      sequencias: 'Automatic numbering of documents, with no gaps or repeats',
      campos: 'Custom fields in forms and tables',
      'campos-telas': 'Which fields are shown and which are required on each record screen',
      visoes: 'Filters, columns and sorting you saved in tables',
      modelos: 'Ready-made texts for e-mails, messages and documents',
      estruturas: 'Stages and roles used by the other modules',
      crm: 'Shortcut to the CRM settings: pipelines, loss reasons, proposals and workflows',
    },
  },
};
